export const isAfterDate = (year: number, month: number, day: number): boolean => {
	const now = new Date(); // Get the current date and time
	// Create a Date object for Christmas of the current year
	const dateToCheck = new Date(year, month, day); // Month is 0-based, so 11 = December

	// Check if the current date is after Christmas
	return now > dateToCheck;
};
